import { Overlay } from "../../../../styles/popup";
import PopupPagination from "../../../../component/Pagination/popupPagination";
import { SellerTournamentTicketLogResponse } from "../../../../api/tournament-ticket";
import { formatDateWithDote } from "../../../../utils/date";
import * as S from "./styles";

interface TicketLogPopupProps {
  list: SellerTournamentTicketLogResponse[];
  currentPage: number;
  totalPages: number;
  onClose: () => void;
  onPageChange: (page: number) => void;
}

const COLUMNS = [
  { header: "일시", className: "date" },
  { header: "매장명", className: "pub" },
  { header: "닉네임", className: "nickname" },
  { header: "티켓명", className: "ticket" },
  { header: "구분", className: "type" },
  { header: "수량", className: "count" },
  { header: "비고", className: "memo" },
];

const formatLogDate = (value: Date | string) => {
  const text = formatDateWithDote(value, true);
  const [date, time] = text.split(" ");
  return `${date}\n${time}`;
};

const TicketLogPopup = ({
  list,
  currentPage,
  totalPages,
  onClose,
  onPageChange,
}: TicketLogPopupProps) => {
  return (
    <Overlay $zIndex={1000}>
      <S.Popup>
        <S.Header>
          <div className="title">티켓 내역</div>
          <img
            src="/image-web/tournament/close.svg"
            alt="close"
            onClick={onClose}
          />
        </S.Header>

        <S.TableContent>
          <S.TableHeader>
            {COLUMNS.map((column) => (
              <div
                key={column.className}
                className={`item ${column.className}`}
              >
                {column.header}
              </div>
            ))}
          </S.TableHeader>

          <S.ListWrapper>
            {list.length === 0 ? (
              <S.EmptyMessage>티켓 내역이 없습니다.</S.EmptyMessage>
            ) : (
              list.map((item, index) => (
                <S.TableItem key={`${item.nickname}-${item.createdAt}-${index}`}>
                  <div className="item date">
                    {formatLogDate(item.createdAt)}
                  </div>
                  <div className="item pub">
                    <span>{item.pubName}</span>
                  </div>
                  <div className="item nickname">
                    <span>{item.nickname}</span>
                  </div>
                  <div className="item ticket">{item.ticketName}</div>
                  <div className="item type">{item.type}</div>
                  <div className="item count">{item.count}</div>
                  <div className="item memo">{item.memo || "-"}</div>
                </S.TableItem>
              ))
            )}
          </S.ListWrapper>
        </S.TableContent>

        {totalPages > 1 && (
          <S.PaginationBox>
            <PopupPagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </S.PaginationBox>
        )}
      </S.Popup>
    </Overlay>
  );
};

export default TicketLogPopup;
